var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-item-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "field": _vm.field,
      "rules": _vm.rules,
      "design-state": _vm.designState,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList,
      "sub-form-row-index": _vm.subFormRowIndex,
      "sub-form-col-index": _vm.subFormColIndex,
      "sub-form-row-id": _vm.subFormRowId
    }
  }, [_c('el-upload', {
    ref: "fieldEditor",
    class: {
      'hideUploadDiv': _vm.uploadBtnHidden || _vm.isReadMode
    },
    attrs: {
      "disabled": _vm.field.options.disabled || _vm.isReadMode,
      "action": _vm.realUploadURL,
      "headers": _vm.uploadHeaders,
      "data": _vm.uploadData,
      "with-credentials": _vm.field.options.withCredentials,
      "multiple": _vm.field.options.multipleSelect,
      "file-list": _vm.fileList,
      "show-file-list": _vm.field.options.showFileList,
      "list-type": "picture-card",
      "limit": _vm.field.options.limit,
      "on-exceed": _vm.handlePictureExceed,
      "on-preview": _vm.handlePicturePreview,
      "before-upload": _vm.beforePictureUpload,
      "on-success": _vm.handlePictureUpload,
      "on-error": _vm.handleUploadError,
      "on-remove": _vm.handlePictureRemove
    }
  }, [(!!_vm.field.options.uploadTip) ? _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.field.options.uploadTip))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), (_vm.showPreviewDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    attrs: {
      "title": "",
      "visible": _vm.showPreviewDialogFlag,
      "append-to-body": "",
      "width": "60%",
      "show-close": true,
      "custom-class": "drag-dialog small-padding-dialog",
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showPreviewDialogFlag = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.previewUrl,
      "width": "100%",
      "alt": ""
    }
  })]) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a1579a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/field-widget/picture-upload-widget.vue
// module id = null
// module chunks = 